<script>
import FeatureCard from "./FeatureCard.vue";

export default {
  components: {
    FeatureCard,
  },
  data() {
    return {
      features: [
        {
          icon: `<svg viewBox="0 0 50 50" class="w-full h-full">
            <defs>
              <linearGradient id="chartGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style="stop-color:#43BFE0;stop-opacity:1" />
                <stop offset="100%" style="stop-color:#AF56FE;stop-opacity:1" />
              </linearGradient>
            </defs>
            <path d="M25 5 A20 20 0 0 1 40 25 L25 25 Z" fill="url(#chartGradient)" />
            <path d="M40 25 A20 20 0 0 1 15 40 L25 25 Z" fill="url(#chartGradient)" opacity="0.7" />
            <path d="M15 40 A20 20 0 0 1 25 5 L25 25 Z" fill="url(#chartGradient)" opacity="0.4" />
          </svg>`,
          title: "Live Results Display",
          description:
            "View responses instantly with real-time updates and dynamic visualizations.",
        },
        {
          icon: `<svg viewBox="0 0 50 50" class="w-full h-full">
            <defs>
              <linearGradient id="schedulerGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style="stop-color:#43BFE0;stop-opacity:1" />
                <stop offset="100%" style="stop-color:#AF56FE;stop-opacity:1" />
              </linearGradient>
            </defs>
            <circle cx="25" cy="25" r="18" fill="none" stroke="url(#schedulerGradient)" stroke-width="3"/>
            <path d="M25 10 L25 25 L35 35" stroke="url(#schedulerGradient)" stroke-width="3" fill="none" stroke-linecap="round"/>
          </svg>`,
          title: "Smart Scheduling",
          description:
            "Schedule polls for optimal engagement with intelligent timing recommendations.",
        },
        {
          icon: `<svg viewBox="0 0 50 50" class="w-full h-full">
            <defs>
              <linearGradient id="targetGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style="stop-color:#43BFE0;stop-opacity:1" />
                <stop offset="100%" style="stop-color:#AF56FE;stop-opacity:1" />
              </linearGradient>
            </defs>
            <circle cx="25" cy="25" r="18" fill="none" stroke="url(#targetGradient)" stroke-width="3"/>
            <circle cx="25" cy="25" r="12" fill="none" stroke="url(#targetGradient)" stroke-width="2"/>
            <circle cx="25" cy="25" r="6" fill="none" stroke="url(#targetGradient)" stroke-width="2"/>
            <circle cx="25" cy="25" r="2" fill="url(#targetGradient)"/>
          </svg>`,
          title: "Targeted Audiences",
          description:
            "Reach specific demographics with precise audience targeting and segmentation.",
        },
        {
          icon: `<svg viewBox="0 0 50 50" class="w-full h-full">
            <defs>
              <linearGradient id="chartGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style="stop-color:#43BFE0;stop-opacity:1" />
                <stop offset="100%" style="stop-color:#AF56FE;stop-opacity:1" />
              </linearGradient>
            </defs>
            <path d="M25 5 A20 20 0 0 1 40 25 L25 25 Z" fill="url(#chartGradient)" />
            <path d="M40 25 A20 20 0 0 1 15 40 L25 25 Z" fill="url(#chartGradient)" opacity="0.7" />
            <path d="M15 40 A20 20 0 0 1 25 5 L25 25 Z" fill="url(#chartGradient)" opacity="0.4" />
          </svg>`,
          title: "Live Results Display",
          description:
            "View responses instantly with real-time updates and dynamic visualizations.",
        },
      ],
    };
  },
};
</script>

<template>
  <div
    id="why-chat-polls"
    class="max-w-screen-xl 2xl:max-w-screen-2xl mx-6 sm:mx-auto bg-primary-dark rounded-[20px] sm:rounded-[40px] xl:rounded-[60px] py-12 px-6 sm:py-16 sm:px-12 lg:py-20 lg:px-20 xl:py-24 xl:px-28 my-12 sm:my-16 lg:my-20 xl:my-32 flex flex-col gap-y-12 sm:gap-y-16 lg:gap-y-20 xl:gap-y-24 items-center justify-center"
  >
    <h2
      class="uppercase text-3xl sm:text-4xl lg:text-5xl xl:text-5.5xl leading-none font-bold font-poppins text-white text-center"
    >
      Features That Make Polling<br />Effortless
    </h2>

    <!-- Features Grid -->
    <div
      class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6 sm:gap-8 w-full max-w-7xl"
    >
      <FeatureCard
        v-for="(feature, index) in features"
        :key="index"
        :icon="feature.icon"
        :title="feature.title"
        :description="feature.description"
      />
    </div>
  </div>
</template>
